// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question-table .divRow {
    margin: 17px 0px !important;
    padding: 5px 22px;
    /* margin-right: 2px !important; */
}

.question-table .headRow {
    padding: 13px 24px;
}

.question-table .divRow .divCell:nth-child(1),
.question-table .headRow .divCell:nth-child(1) {
    width: 110px;
}

.question-table .headRow .divCell:nth-child(3),
.question-table .headRow .divCell:nth-child(4) {
    width: 120px;
    margin-right: 15px;
    padding-left: 27px;

}

.question-table .divRow .divCell:nth-child(3),
.question-table .divRow .divCell:nth-child(4),
.question-table .headRow .divCell:nth-child(3),
.question-table .headRow .divCell:nth-child(4) {
    width: 120px;
    margin-right: 15px;
}

.question-table .divRow .divCell:nth-child(2),
.question-table .headRow .divCell:nth-child(2) {
    width: 850px;
    font-size: 14px !important;
}

.question-table .divRow .divCell:nth-child(2) {
    color: var(--table-text-color) !important;
}

.question-table .divRow .divCell:nth-child(6),
.question-table .divRow .divCell:nth-child(5),
.question-table .headRow .divCell:nth-child(6),
.question-table .headRow .divCell:nth-child(5) {
    min-width: 34px !important;
    max-width: 34px;
}

.question-table .divRow .divCell:nth-child(6),
.question-table .divRow .divCell:nth-child(5) {
    display: flex;
    justify-content: center;
}

.question-table .divRow .divCell:nth-child(6) {
    padding-right: 0px !important;
}

.question-table .divRow .divCell:nth-child(3) button:focus {
    cursor: none !important;
}

.question-table .divRow .divCell:nth-child(4),
.question-table .divRow .divCell:nth-child(5),
.question-table .divRow .divCell:nth-child(6) {
    cursor: pointer;
}

.question-table .divRow .divCell:nth-child(4).client-detail {
    position: relative;
}

.button-sm {
    background-color: #ECF1FE;
    padding: 10px !important;
    border-radius: 6px;
    color: var(--black);
    font-family: var(--Inter-SemiBold600);
    font-size: 10px;
    text-align: center;
    width: 98px;
    height: 32px;
}

.question-table .divRow .divCell:nth-child(3) .button-sm {

    border-radius: 6px;
    border: 1px solid #E9EFFF;
    background: var(--white);
}

.client-detail img {
    position: absolute;
    top: 12px;
    right: 41px;
}

/* Question detail styles */

.question-detail-cantainer {
    border-radius: 6px;
    background: #F4F7FE;
    min-height: 103px;
    padding: 15px 20px;
    margin-left: 20px;
    margin-right: 5px;
}

.question-detail-cantainer .option-container div p,
.question-detail-cantainer div:nth-child(1) p {
    color: #010101;
    font-family: Inter;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 26px;
    letter-spacing: -0.2px;
    text-transform: uppercase;
}

.question-detail-cantainer div:nth-child(1) {
    display: flex;
    flex-direction: row;
}

.question-detail-cantainer div:nth-child(1) p {
    margin-right: 20px !important;
}

.question-detail-cantainer div:nth-child(1) p span {
    padding-left: 10px !important;
}

.question-detail-cantainer div:nth-child(1) p span {
    color: #8F9BBA;
    font-family: Inter;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 26px;
    letter-spacing: -0.2px;
    text-transform: none;
}

.question-detail-cantainer .option-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;

}

.question-detail-cantainer .option-container>div {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 50px;
    margin-top: 10px;
}

.question-detail-cantainer .option-container div .box {
    width: 12px;
    height: 12px;
    background: #D9D9D9;
    margin-right: 10px;
}

.question-detail-cantainer .option-container div p {
    border-radius: 6px;
    border: 1px solid var(--background-color1);
    background: var(--white);
    padding: 2px 14px !important;
    margin-right: 0px !important;
}
.disabled{
    cursor: not-allowed !important;
}
.icons-diabled svg {
    opacity: 0.7;
    cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/styles/QuestionTable.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;;AAEtB;;AAEA;;;;IAII,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;;;;IAII,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,qCAAqC;IACrC,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA,2BAA2B;;AAE3B;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;;IAEI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;;AAEnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,0CAA0C;IAC1C,wBAAwB;IACxB,4BAA4B;IAC5B,4BAA4B;AAChC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,eAAe;AACnB","sourcesContent":[".question-table .divRow {\n    margin: 17px 0px !important;\n    padding: 5px 22px;\n    /* margin-right: 2px !important; */\n}\n\n.question-table .headRow {\n    padding: 13px 24px;\n}\n\n.question-table .divRow .divCell:nth-child(1),\n.question-table .headRow .divCell:nth-child(1) {\n    width: 110px;\n}\n\n.question-table .headRow .divCell:nth-child(3),\n.question-table .headRow .divCell:nth-child(4) {\n    width: 120px;\n    margin-right: 15px;\n    padding-left: 27px;\n\n}\n\n.question-table .divRow .divCell:nth-child(3),\n.question-table .divRow .divCell:nth-child(4),\n.question-table .headRow .divCell:nth-child(3),\n.question-table .headRow .divCell:nth-child(4) {\n    width: 120px;\n    margin-right: 15px;\n}\n\n.question-table .divRow .divCell:nth-child(2),\n.question-table .headRow .divCell:nth-child(2) {\n    width: 850px;\n    font-size: 14px !important;\n}\n\n.question-table .divRow .divCell:nth-child(2) {\n    color: var(--table-text-color) !important;\n}\n\n.question-table .divRow .divCell:nth-child(6),\n.question-table .divRow .divCell:nth-child(5),\n.question-table .headRow .divCell:nth-child(6),\n.question-table .headRow .divCell:nth-child(5) {\n    min-width: 34px !important;\n    max-width: 34px;\n}\n\n.question-table .divRow .divCell:nth-child(6),\n.question-table .divRow .divCell:nth-child(5) {\n    display: flex;\n    justify-content: center;\n}\n\n.question-table .divRow .divCell:nth-child(6) {\n    padding-right: 0px !important;\n}\n\n.question-table .divRow .divCell:nth-child(3) button:focus {\n    cursor: none !important;\n}\n\n.question-table .divRow .divCell:nth-child(4),\n.question-table .divRow .divCell:nth-child(5),\n.question-table .divRow .divCell:nth-child(6) {\n    cursor: pointer;\n}\n\n.question-table .divRow .divCell:nth-child(4).client-detail {\n    position: relative;\n}\n\n.button-sm {\n    background-color: #ECF1FE;\n    padding: 10px !important;\n    border-radius: 6px;\n    color: var(--black);\n    font-family: var(--Inter-SemiBold600);\n    font-size: 10px;\n    text-align: center;\n    width: 98px;\n    height: 32px;\n}\n\n.question-table .divRow .divCell:nth-child(3) .button-sm {\n\n    border-radius: 6px;\n    border: 1px solid #E9EFFF;\n    background: var(--white);\n}\n\n.client-detail img {\n    position: absolute;\n    top: 12px;\n    right: 41px;\n}\n\n/* Question detail styles */\n\n.question-detail-cantainer {\n    border-radius: 6px;\n    background: #F4F7FE;\n    min-height: 103px;\n    padding: 15px 20px;\n    margin-left: 20px;\n    margin-right: 5px;\n}\n\n.question-detail-cantainer .option-container div p,\n.question-detail-cantainer div:nth-child(1) p {\n    color: #010101;\n    font-family: Inter;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 26px;\n    letter-spacing: -0.2px;\n    text-transform: uppercase;\n}\n\n.question-detail-cantainer div:nth-child(1) {\n    display: flex;\n    flex-direction: row;\n}\n\n.question-detail-cantainer div:nth-child(1) p {\n    margin-right: 20px !important;\n}\n\n.question-detail-cantainer div:nth-child(1) p span {\n    padding-left: 10px !important;\n}\n\n.question-detail-cantainer div:nth-child(1) p span {\n    color: #8F9BBA;\n    font-family: Inter;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 26px;\n    letter-spacing: -0.2px;\n    text-transform: none;\n}\n\n.question-detail-cantainer .option-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n\n}\n\n.question-detail-cantainer .option-container>div {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-right: 50px;\n    margin-top: 10px;\n}\n\n.question-detail-cantainer .option-container div .box {\n    width: 12px;\n    height: 12px;\n    background: #D9D9D9;\n    margin-right: 10px;\n}\n\n.question-detail-cantainer .option-container div p {\n    border-radius: 6px;\n    border: 1px solid var(--background-color1);\n    background: var(--white);\n    padding: 2px 14px !important;\n    margin-right: 0px !important;\n}\n.disabled{\n    cursor: not-allowed !important;\n}\n.icons-diabled svg {\n    opacity: 0.7;\n    cursor: default;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
